import { workOrderQueryAtom } from '../_graphql/queryWorkOrder';

import { atomFromRoutePath } from '~/shared/state';

export const $workOrderIdParam = atomFromRoutePath(
  '/production/work-orders/:workOrderId',
);

export const $remoteWorkOrder = workOrderQueryAtom((get) => {
  const params = get($workOrderIdParam);
  const workOrderId = params?.workOrderId;

  if (!workOrderId) {
    return { skip: true, variables: { id: '' } };
  }

  return {
    variables: { id: workOrderId },
  };
});
